import type { ChatMessage, ChatMessageDebug } from '../stores/editorStore';
import type { ChatSendResponse } from './aiChatClient';
import type { AiActionResult } from './aiActionExecutor';
import { parseAssistantResponse, type ParsedAssistantResponse } from './aiResponseParser';

export interface ProcessAiProviderResponseOptions {
  captureDebug: boolean;
  executeActions: (parsed: ParsedAssistantResponse) => Promise<AiActionResult[]>;
}

/** Provider yanıtı gelir gelmez parse, action execution ve debug snapshot üretir. */
export async function processAiProviderResponse(
  response: ChatSendResponse,
  options: ProcessAiProviderResponseOptions
): Promise<ChatMessage> {
  const parsed = parseAssistantResponse(response.content);
  const executionResults = await options.executeActions(parsed);

  let debug: ChatMessageDebug | undefined;
  if (options.captureDebug) {
    debug = {
      jobs: parsed.jobs,
      actions: parsed.actions,
      payloads: parsed.payloads,
      executionResults,
      receivedAt: new Date().toISOString(),
    };

    console.debug('[aiChat] provider response', {
      messageId: response.id,
      conversationId: response.conversationId,
      contentLength: response.content.length,
      structured: {
        jobs: parsed.jobs.length,
        actions: parsed.actions.length,
        payloads: parsed.payloads.length,
      },
      executionResults,
      jobs: parsed.jobs,
      actions: parsed.actions,
      payloads: parsed.payloads,
    });
  }

  return {
    id: response.id,
    role: 'assistant',
    content: response.content,
    timestamp: new Date(response.timestamp),
    debug,
  };
}
